<template>
  <div class="assistance-summary">
    <h3 class="assistance-summary__title">Itens:</h3>
    <ul v-if="items.length" class="assistance-summary__service-list">
      <li style="white-space: pre-line;" 
        v-for="(item, index) in items" :key="index"
      >{{item.reason}} <span v-if="item.subReason">/ {{item.subReason}}</span></li>
    </ul>

    <div>
      <h3 class="assistance-summary__title">Data e horário:</h3>
      <p class="assistance-summary__text">{{date}}</p>
    </div>
    <div v-if="accompanied && accompanied.name">
      <h3 class="assistance-summary__title">A vistoria será acompanhada por:</h3>
      <p class="assistance-summary__text">{{accompanied.name}} {{accompanied.document && `(${accompanied.document})`}}</p>
    </div>
    <div v-if="address">
      <h3 class="assistance-summary__title">Endereço:</h3>
      <p class="assistance-summary__text">{{address.product}} - {{address.block}}</p>
      <p class="assistance-summary__text">{{address.street}}, {{address.number}} - {{address.neighborhood}}, {{address.city}} - {{address.uf}}</p>
    </div>
    <div v-if="requesterName">
      <h3 class="assistance-summary__title">Agendado por:</h3>
      <p class="assistance-summary__text">{{requesterName}}</p>
    </div>
      <div v-if="ticketCreationNotice">
      <h3 class="assistance-summary__title">Aviso:</h3>
      <p class="assistance-summary__text" v-html="ticketCreationNotice"></p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'assistance-summary',
    props: {
      items: Array,
      accompanied: Object,
      date: String,
      address: Object,
      requesterName: String,
      ticketCreationNotice: String
    }
  }
</script>

<style lang="scss" scoped>
  .assistance-summary {
    background-color: #EEEEEE;
    text-align: center;
    padding: 10px 0 20px;

    &__title {
      color: #0093F0;
      display: inline-block;
      margin-top: 10px;
      font-size: 16px;
    }

    &__service-list {
      list-style: none;
      font-size: 14px;
    }

    &__text {
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// ./src/components/AssistanceSummary.vue